export class _NavigationStore {
  private static instance: _NavigationStore | null = null;

  public previousRoute = ref<string | null>(null);

  private constructor() {}

  public static getInstance() {
    if (!_NavigationStore.instance) {
      _NavigationStore.instance = new _NavigationStore();
    }
    return _NavigationStore.instance;
  }

  public setPrevious(route: string) {
    const fullUrl = this.createFullUrl(route);
    this.previousRoute.value = fullUrl;
  }

  private createFullUrl(route: string): string {
    if (route.startsWith('http')) {
      return route;
    }

    const baseUrl = window.location.origin;
    return `${baseUrl}${route}`;
  }

  public reset() {
    this.previousRoute.value = null;
  }
}

export const NavigationStore = _NavigationStore.getInstance();
